import styled from "styled-components";

export const ConfirmContainer = styled.div`
  padding: 32px 0;
  .dealer-box {
    position: relative;
    .edit-icon {
      font-size: 24px;
      position: absolute;
      top: 16px;
      left: 16px;
      cursor: pointer;
      color: #222;
    }
    background: #fff;
    border: solid 1px ${({ theme }) => theme.colors.lightFont};
    margin: 16px 0;
    border-radius: 10px;
    padding: 16px;
    .text,
    .province-city {
      font-weight: bold;
    }
  }
  .recaptcha {
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    justify-content: space-between;
    .policy {
      display: flex;
      align-items: center;
      font-size: 14px;
      input {
        height: 20px;
        width: 20px;
        margin-left: 10px;
      }
      label {
        padding-top: 5px;
        span {
          cursor: pointer;
          color: #ca6a43;
        }
      }
    }
  }
  .buttons {
    display: flex;
    justify-content: space-between;
  }
  .sample-contract{
    display: block;
    margin-bottom: 8px;
  }
`;
